import React, { Component } from 'react'
import Constantes from '../php/Constantes';
import { Box, CircularProgress, Container, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, styled, tableCellClasses } from '@mui/material';

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));


let filasTotales = 0;
const opcionesFilasPorPagina = [5, 10, 25, 50, 100];

class NivelEducativoPersonal extends Component {
    constructor(props){
        super(props);
        this.state = {
            //------------------
            pagina: 0,
            filasPorPagina: 5,
            //------------------
            resumenNiveles: {},
            errores: null,
            notificaciones: null,
            loading: false,
            consultaRealizada: false,
            datosConsulta: [],
        }
        this.manejarEnviarConsulta = this.manejarEnviarConsulta.bind(this);
    }

    async componentDidMount(){
        this.setState({
            loading: true,
        })
        const lugar = await fetch(`${Constantes.RUTA_API}/obtener_nivelesEducativos.php`);
        const datoLugar = await lugar.json();
        this.setState({
            loading: false,
            resumenNiveles: datoLugar[0],
        });
    }

    handleChangePage = (event, nuevaPagina) => {
        this.setState({ pagina: nuevaPagina });
    };
    
    handleChangeRowsPerPage = (event) => {
        const filasPorPagina = event.target.value === 'all' ? this.state.datosConsulta.length : parseInt(event.target.value, 10);
        this.setState({ filasPorPagina, pagina: 0 });
    };

    render(){
        const { pagina, filasPorPagina } = this.state;
        filasTotales = this.state.datosConsulta.length;
        return (
            <>
                <h3>Nivel Educativo</h3>
                {this.state.loading
                ?
                    <div style={{placeItems: 'center'}}>
                        <Box sx={{alignItems: 'center'}}>
                            <CircularProgress/>
                        </Box>
                    </div>
                :
                    null
                }
                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                <br/>
                {this.state.consultaRealizada
                ?
                    <Container>
                        <TableContainer style={{width: '70%', marginLeft:'auto', marginRight:'auto', marginBottom: '2rem'}} component={Paper}>
                            <Table sx={{minWidth: 700}}>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell style={{textAlign: 'center'}}>Número Funcionario</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>Nombre Funcionario</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.datosConsulta.slice(this.state.pagina * this.state.filasPorPagina, this.state.pagina * this.state.filasPorPagina + this.state.filasPorPagina).map((name) => (
                                        <StyledTableRow key={name.numeroFuncionario}>
                                            <StyledTableCell style={{textAlign: 'center'}}>{name.numeroFuncionario}</StyledTableCell>
                                            <StyledTableCell style={{textAlign: 'center'}}>{name.primerNombre} {name.primerApellido}</StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination style={{width: '70%'}} rowsPerPageOptions={opcionesFilasPorPagina} component="div" count={filasTotales} rowsPerPage={this.state.filasPorPagina} page={this.state.pagina} onPageChange={this.handleChangePage} onRowsPerPageChange={this.handleChangeRowsPerPage} labelRowsPerPage="Filas por página" SelectProps={{inputProps: {'aria-label': 'Filas por página',}, displayEmpty: true,}}/>
                    </Container>
                :
                    <Container>
                        <TableContainer style={{width: '70%', marginLeft:'auto', marginRight:'auto', marginBottom: '2rem'}} component={Paper}>
                            <Table sx={{minWidth: 700}}>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell style={{textAlign: 'center'}}>Formación</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>Hombres</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>Mujeres</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <StyledTableRow>
                                        <StyledTableCell style={{textAlign: 'center'}}>Primaria</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{this.state.resumenNiveles.primariaHombres}</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{this.state.resumenNiveles.primariaMujeres}</StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                        <StyledTableCell style={{textAlign: 'center'}}>Secundaria</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{this.state.resumenNiveles.secundariaHombres}</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{this.state.resumenNiveles.secundariaMujeres}</StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                        <StyledTableCell style={{textAlign: 'center'}}>Terciario no universitario</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{this.state.resumenNiveles.terciariaHombres}</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{this.state.resumenNiveles.terciariaMujeres}</StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                        <StyledTableCell style={{textAlign: 'center'}}>Grado universitario</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{this.state.resumenNiveles.gradoHombres}</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{this.state.resumenNiveles.gradoMujeres}</StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                        <StyledTableCell style={{textAlign: 'center'}}>Maestría universitaria</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{this.state.resumenNiveles.maestriaHombres}</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{this.state.resumenNiveles.maestriaMujeres}</StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                        <StyledTableCell style={{textAlign: 'center'}}>Posgrado universitario</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{this.state.resumenNiveles.posgradoHombres}</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{this.state.resumenNiveles.posgradoMujeres}</StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                        <StyledTableCell style={{textAlign: 'center'}}>Doctorado universitario</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{this.state.resumenNiveles.doctoradoHombres}</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{this.state.resumenNiveles.doctoradoMujeres}</StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                        <StyledTableCell style={{textAlign: 'center'}}>Ninguno</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{this.state.resumenNiveles.ningunoHombres}</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{this.state.resumenNiveles.ningunoMujeres}</StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                        <StyledTableCell style={{textAlign: 'center'}}>TOTAL</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{this.state.resumenNiveles.totalHombre}</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{this.state.resumenNiveles.totalMujeres}</StyledTableCell>
                                    </StyledTableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <button className="btn btn-outline-primary mx-2" style={{marginTop:'1rem', marginBottom: '2rem'}} type='button' onClick={this.manejarEnviarConsulta}>Consultar Pendientes</button>
                    </Container>
                }
            </>
        )
    }

    async manejarEnviarConsulta(e){
        e.preventDefault();
        this.setState({
            loading: true,
        })
        const cargaUtil = JSON.stringify([sessionStorage.numeroFuncionario, sessionStorage.nombreFuncionario, this.state.nivel]);

        const infoSol = await fetch(`${Constantes.RUTA_API}/obtener_pendientesNivelEducativo.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await infoSol.json();

        this.setState({
            errores: res[0],
            loading: false,
        })

        if(res[0] === 'ok'){
            this.setState({
                errores: null,
                consultaRealizada: true,
                datosConsulta: res[1],
            })
        }
    }
}

export default NivelEducativoPersonal